/* This file was generated automatically. Do not edit manually. */

export enum OrderItemType {
    CancellationFee = 'CancellationFee',
    NightRebate = 'NightRebate',
    ProductOrderRebate = 'ProductOrderRebate',
    AdditionalExpenseRebate = 'AdditionalExpenseRebate',
    Deposit = 'Deposit',
    ExchangeRateDifference = 'ExchangeRateDifference',
    CustomItem = 'CustomItem',
    ServiceCharge = 'ServiceCharge',
    CityTax = 'CityTax',
    CityTaxDiscount = 'CityTaxDiscount',
    SpaceOrder = 'SpaceOrder',
    ProductOrder = 'ProductOrder',
    Surcharge = 'Surcharge',
    TaxCorrection = 'TaxCorrection',
    ResourceUpgradeFee = 'ResourceUpgradeFee',
    InvoiceFee = 'InvoiceFee',
    MulticurrencyFee = 'MulticurrencyFee',
    AllowanceDiscount = 'AllowanceDiscount',
    AllowanceBreakage = 'AllowanceBreakage',
    AllowanceContraBreakage = 'AllowanceContraBreakage',
}
